module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Selected-file-3eef9a744e743bfdf42d6cc44549b34a.svg";